import { render } from "./OwnerStatement.vue?vue&type=template&id=5d988c38&scoped=true"
import script from "./OwnerStatement.vue?vue&type=script&lang=js"
export * from "./OwnerStatement.vue?vue&type=script&lang=js"

import "./OwnerStatement.vue?vue&type=style&index=0&id=5d988c38&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d988c38"]])

export default __exports__